import { settingsPath } from './settingsSections';

/**
 * A link straight to the terms of one school year.
 *
 * The schedule and course pages send an administrator here when something they
 * need — a term to hang a class on — does not exist yet, so the link has to
 * land on the right year, not just the right section.
 */
export function schoolYearSettingsPath(schoolSlug: string, yearSlug?: string | null) {
  const base = settingsPath(schoolSlug, 'school-years');
  const search = yearSlug ? `?year=${encodeURIComponent(yearSlug)}` : '';

  return `${base}${search}#academic-terms`;
}
